import DesignBox from "@/assets/svgs/DesignBox";
import PurpleBg from "@/assets/svgs/PurpleBg";
import Settings from "@/assets/svgs/Settings";
import Star from "@/assets/svgs/Star";
import React from "react";

type ComparisonCardsProps = {
  competitorLogo: string;
  graphyFeatures: string[];
  competitorFeatures: string[];
  isRight: boolean;
  emoji: string;
};

const ComparisonCards: React.FC<ComparisonCardsProps> = ({
  competitorLogo,
  emoji,
  graphyFeatures,
  competitorFeatures,
  isRight,
}) => {
  return (
    <div
      className={`flex justify-center xl:max-w-xl
      `}
    >
      <div
        className="xl:shadow-above md:-left-15  bottom-shadow-purple-xl relative 
      h-fit w-1/2 rounded-xl border border-purple-3 bg-white px-3 
      py-8 md:w-64 md:px-6 md:py-8"
      >
        <div
          className={` ${
            !isRight
              ? "right-48 hidden  md:-left-7 md:top-2  md:block"
              : "-top-8 left-9 md:-left-8 md:-top-8"
          }  absolute -z-30 flex h-44 w-44`}
        >
          {isRight ? <Settings /> : <Star />}
        </div>
        <div className="absolute -top-9 left-32 z-30 flex h-16 w-16 items-center justify-center rounded-full bg-white text-3xl shadow-md xl:-top-8 xl:left-56 xl:flex 2xl:left-56">
          {emoji}
        </div>
        <img
          src="/images/graphy-logo.svg"
          alt="Graphy Logo"
          className="mx-auto mb-6"
          width={100}
        />
        <div className="flex flex-col items-center justify-center gap-[15px]">
          {graphyFeatures.map((feature) => (
            <div
              className="flex w-full flex-col items-center gap-3  md:flex-row md:items-start xl:w-52"
              key={feature}
            >
              <img
                src="/images/icons/greentick.svg"
                className="ml-1 mt-1"
                alt="Green Tick"
              />
              <p className="text-center text-body-14 text-grey-4 sm:text-sm md:text-start">
                {feature}
              </p>
            </div>
          ))}
        </div>
        <div className="absolute -right-36 -bottom-12 -z-50  md:-right-36 md:top-32">
        <PurpleBg />
      </div>
      </div>
      
      <div className="md:max-w-64 mt-4 h-fit  w-1/2 gap-2.5 rounded-xl  border border-l-0 border-grey-3  bg-white px-3 py-4 md:mt-2 md:p-6 xl:shadow-dark relative">
        <img
          src={competitorLogo}
          alt="Competitor Logo"
          width={130}
          className="mx-auto mb-6"
        />
        <div className="flex flex-col items-center justify-center gap-4">
          {competitorFeatures.map((feature, index) => (
            <div
              className="flex w-full flex-col items-center gap-3  md:flex-row md:items-start xl:w-52"
              key={index}
            >
              <img
                src="/images/icons/redcross.svg"
                className="ml-1 mt-1"
                alt="Green Tick"
              />
              <p className="text-center text-body-14 text-grey-4 sm:text-sm md:text-start">
                {feature}
              </p>
            </div>
          ))}
        </div>
        
      <div className="absolute -top-20 right-0 -z-50 md:-top-20 md:right-20">
        <DesignBox />
      </div>
      </div>
    
    </div>
  );
};
export default ComparisonCards;
